import { render, staticRenderFns } from "./ContributionsPage.vue?vue&type=template&id=22c6d7aa"
import script from "./ContributionsPage.vue?vue&type=script&lang=js"
export * from "./ContributionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports